module.exports = __webpack_public_path__ + "static/media/dolly-flatbed-alt.124a7467.svg";